import React from 'react';
import { ClipboardListIcon, GiftIcon, ReplaceIcon, ShoppingCartIcon, UtensilsCrossedIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { CTAButton } from './CTAButton';
import { BONOS } from './salesData';
const ICONS = [ShoppingCartIcon, ClipboardListIcon, ReplaceIcon, UtensilsCrossedIcon, GiftIcon];

/** Los 5 bonos exclusivos que van de regalo con la compra. */
export function BonosSection() {
  return <section id="bonos" className="w-full border-b border-line bg-ink" data-id="element-30" data-mp="th1g3mhuad6l">
      <div className="mx-auto max-w-6xl px-5 py-16 sm:px-8 sm:py-20" data-id="element-31" data-mp="oflvtwnhkap9">
        <div className="max-w-2xl" data-id="element-32" data-mp="kejqcy2z72eu">
          <SectionTag data-id="element-33" data-mp="kfuxn7vmqsap">De regalo con tu compra</SectionTag>
          <h2 className="mt-4 font-condensed text-[2.1rem] uppercase leading-[0.95] text-bone sm:text-5xl" data-id="element-34" data-mp="fg8k0xbw3a1d">
            <span className="text-glow-gold" data-id="element-35" data-mp="2etm9me1flo9b">5 bonos exclusivos</span> para que cocinar sea todavía
            más fácil
          </h2>
        </div>

        <ul className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-36" data-mp="29urmx10cffjx">
          {BONOS.map((bono, index) => {
          const Icon = ICONS[index] ?? GiftIcon;
          const featured = index === BONOS.length - 1;
          return <li key={bono.numero} className={`flex h-full flex-col rounded-2xl border p-6 ${featured ? 'border-gold/40 bg-gold/[0.07] lg:col-span-1' : 'border-line bg-carbon-soft'}`} data-id="element-37" data-mp="hv9etyk13w1i" data-mpi={index}>
                <div className="flex items-center justify-between gap-3" data-id="element-38" data-mp="1el8ppznnj6n9">
                  <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold/12 text-gold" data-id="element-39" data-mp="10tu3zl2d0rci">
                    <Icon className="h-5 w-5" aria-hidden strokeWidth={2} data-id="element-40" data-mp="15s5c9rd0atsm" />
                  </span>
                  <span className="font-condensed text-2xl leading-none text-gold/35" data-id="element-41" data-mp="1thpxkgwmu352">
                    {bono.numero}
                  </span>
                </div>
                <h3 className="mt-5 font-display text-[1rem] leading-snug text-bone" data-id="element-42" data-mp="1yasw73g9o2s4">
                  {bono.titulo}
                </h3>
                <p className="mt-2.5 text-[0.9rem] leading-relaxed text-ash" data-id="element-43" data-mp="235luvmh1sbql">{bono.descripcion}</p>
                <p className="mt-auto pt-5" data-id="element-44" data-mp="1y5zej45xafdk">
                  <span className="rounded bg-gold px-2 py-0.5 font-display text-[0.56rem] uppercase tracking-editorial text-ink" data-id="element-45" data-mp="1y8ve0wxf5c44">
                    {bono.formato}
                  </span>
                </p>
              </li>;
        })}
        </ul>

        <div className="mt-10" data-id="element-46" data-mp="1kech3108v0t7">
          <CTAButton data-id="element-47" data-mp="1kdav41howtwp" />
        </div>
      </div>
    </section>;
}